import {isNil} from 'ramda';

import {StatisticsCar} from '../../../types/api/api';
import {PriceReportType} from '../../../types/PriceReportType';
import {ExtendedStatisticsCar} from '../components/Chart/types/ExtendedStatisticsCar';

export function markMyAd(
  cars: StatisticsCar[],
  priceReport: PriceReportType
): ExtendedStatisticsCar[] {
  if (isNil(priceReport.vehicle.adId)) {
    return cars.map((car) => ({
      ...car,
      isMyAd: false,
    }));
  }

  return cars.map((car) => ({
    ...car,
    isMyAd: car.ad_id === priceReport.vehicle.adId,
  }));
}
